import React from "react";
import { Link } from 'react-router-dom';

import useDialog from '../../hooks/useDialog';
import Button from '../../components/buttons/Button';
import Layout from '../../components/Layout';
import CustomLink from '../../components/links/CustomLink';

const Home: React.FC = () => {
  const [status, setStatus] = React.useState<string>(
    'Click one of the dialog!'
  );

  const dialog = useDialog();

  function openDanger() {
    setStatus('Danger Dialog Opened');
    dialog({
      title: 'Danger!',
      description: (
        <>
          This is a <strong className='text-red-600'>danger dialog</strong>.
        </>
      ),
      catchOnCancel: true,
      submitText: 'OH YES',
      variant: 'danger',
    })
      .then(() => setStatus('Danger Dialog: Submitted'))
      .catch(() => setStatus('Danger Dialog: Rejected'));
  }

  function openWarning() {
    setStatus('Warning Dialog Opened');
    dialog({
      title: 'Warning!',
      description: (
        <>
          This is a <strong className='text-yellow-600'>warning dialog</strong>.
        </>
      ),
      catchOnCancel: true,
      submitText: 'Okay',
      variant: 'warning',
    })
      .then(() => setStatus('Warning Dialog: Submitted'))
      .catch(() => setStatus('Warning Dialog: Rejected'));
  }

  function openSuccess() {
    setStatus("Success Dialog Opened (this one don't catch reject)");
    dialog({
      title: 'Success!',
      description: (
        <>
          This is a <strong className='text-green-600'>success dialog</strong>.
        </>
      ),
      // Can be omitted
      catchOnCancel: false,
      submitText: 'Cool',
      variant: 'success',
    }).then(() => setStatus('Success Dialog: Submitted'));
  }

  return (
    <Layout>
      <main>
        <section>
          <div className='flex flex-col items-center justify-center min-h-screen text-center layout'>
            <h1 className='text-2xl md:text-4xl'>Social engagement NFT</h1>
            <p className='mt-2 text-sm text-gray-800'>
              An exploration with proof of interaction on the blockchain
            </p>

            <div className='flex flex-col gap-2 mt-6 md:flex-row'>
              <Button>
                <Link className="mainLink" to="/new">New Engagement</Link>
              </Button>
              <Button>
                <Link className="mainLink" to="/collection">Explore past interactions</Link>
              </Button>
              <Button>
                <Link className="mainLink" to="/graph">Engagement topology graph</Link>
              </Button>
              {/* <Button onClick={openDanger}>Danger Dialog</Button>
              <Button onClick={openWarning}>Warning Dialog</Button>
              <Button onClick={openSuccess}>Success Dialog</Button> */}
            </div>

            {/* <div className='mt-8'>
              <p className='font-semibold underline'>Status</p>
              <p className='mt-2 text-sm text-gray-800'>{status}</p>
            </div> */}

            <footer className='absolute text-gray-700 bottom-2'>
              Made with &hearts; By{' '}
              <CustomLink href='https://devpost.com/software/social-engager-nft'>
                Team Amun @ ETH Lisbon 2021
              </CustomLink>
            </footer>
          </div>
        </section>
      </main>
    </Layout>
  );
};

export default Home;
